const ALLOWED_TAGS = new Set([
  'A',
  'BR',
  'EM',
  'LI',
  'OL',
  'P',
  'SPAN',
  'STRONG',
  'UL',
]);

const ALLOWED_ATTRS: Record<string, Set<string>> = {
  A: new Set(['href', 'target', 'rel']),
};

const DROP_WITH_CONTENT = new Set(['IFRAME', 'OBJECT', 'SCRIPT', 'STYLE']);

function isSafeHref(value: string): boolean {
  const trimmed = value.trim().toLowerCase();
  return (
    trimmed.startsWith('https://') ||
    trimmed.startsWith('http://') ||
    trimmed.startsWith('mailto:') ||
    trimmed.startsWith('tel:')
  );
}

function cleanNode(node: Node): Node | null {
  if (node.nodeType === Node.TEXT_NODE) {
    return document.createTextNode(node.textContent ?? '');
  }
  if (node.nodeType !== Node.ELEMENT_NODE) return null;

  const element = node as Element;
  if (DROP_WITH_CONTENT.has(element.tagName)) return null;
  if (!ALLOWED_TAGS.has(element.tagName)) {
    const fragment = document.createDocumentFragment();
    element.childNodes.forEach((child) => {
      const clean = cleanNode(child);
      if (clean) fragment.appendChild(clean);
    });
    return fragment;
  }

  const clean = document.createElement(element.tagName.toLowerCase());
  const attrs = ALLOWED_ATTRS[element.tagName] ?? new Set<string>();
  for (const attr of Array.from(element.attributes)) {
    if (!attrs.has(attr.name)) continue;
    if (attr.name === 'href' && !isSafeHref(attr.value)) continue;
    clean.setAttribute(attr.name, attr.value);
  }
  if (clean.tagName === 'A') {
    clean.setAttribute('rel', 'noopener noreferrer');
  }
  element.childNodes.forEach((child) => {
    const cleanChild = cleanNode(child);
    if (cleanChild) clean.appendChild(cleanChild);
  });
  return clean;
}

export function sanitizeAnnouncementHtml(html: string): string {
  const template = document.createElement('template');
  template.innerHTML = html;
  const fragment = document.createDocumentFragment();
  template.content.childNodes.forEach((child) => {
    const clean = cleanNode(child);
    if (clean) fragment.appendChild(clean);
  });
  const container = document.createElement('div');
  container.appendChild(fragment);
  return container.innerHTML;
}
